/* KODA Event page behaviour */
(function () {
  if (window.__kodaEvent) return;
  window.__kodaEvent = true;

  /* 1. Click tracking: any element with data-ke-track pushes to dataLayer */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-ke-track]');
    if (!el) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'event_page_click',
      event_link_type: el.getAttribute('data-ke-track'),
      event_link_label: (el.textContent || '').trim(),
      event_handle: el.getAttribute('data-ke-event') || ''
    });
  });

  /* 2. Smooth scroll to in-page anchors (e.g. #rsvp), clearing the sticky header */
  function headerOffset() {
    var h = document.querySelector('sticky-header, .header-wrapper, .section-header');
    var r = h ? h.getBoundingClientRect() : null;
    /* only count the header if it is actually pinned to the top of the viewport */
    return (r && r.top <= 0 && r.bottom > 0 ? r.bottom : (r ? r.height : 0)) + 16;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = decodeURIComponent(a.getAttribute('href').slice(1));
    if (!id) return;
    var target = document.getElementById(id);
    if (!target || !target.closest('#MainContent')) return;

    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);

    /* move keyboard/screen-reader focus to the destination without re-scrolling */
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    setTimeout(function () {
      try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
    }, reduce ? 0 : 600);
  });
})();
